 
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from 'v3/components/Card';
import Text from 'v3/components/Text';
import Input from 'v3/components/Input';
import Button from 'v3/components/Button';
import { useSnackbar } from 'v3/components/Snackbar';
import ApplicationLayout from 'v3/layouts/Application';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';
import api from 'services/api';
import { usePermission } from 'hooks';

function Register() {
  const snackbar = useSnackbar();
  const navigate = useNavigate();
  const [paymentMethod, setPaymentMethod] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  usePermission('CADASTRAR_FORMAS_DE_PAGAMENTO', { redirect: true });

  async function handleRegister() {
    if (paymentMethod !== '')
      try {
        setLoading(true);
        await api.post('payment/methods', { name: paymentMethod });
        setPaymentMethod('');
        setShowModal(true);
      } catch (ex) {
        snackbar.show(<Text>Algo deu errado ao cadastrar a forma de pagamento.</Text>, {
          type: 'error',
        });
      } finally {
        setLoading(false);
      }
  }

  const handleCloseModal = () => setShowModal(false);

  return (
    <ApplicationLayout
      title="Forma de pagamento"
      RightComponent={
        <>
          <Button variant="secondary" onClick={() => navigate.goBack()}>
            <Text weight={500} color="dark" type="regular">
              Cancelar
            </Text>
          </Button>
          <Button variant="success" loading={loading} onClick={() => handleRegister()}>
            <Text weight={500} color="white" type="regular">
              Salvar
            </Text>
          </Button>
        </>
      }
    >
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        className="payment-method-created-modal"
        backdropClassName="payment-method-created-modal-backdrop"
      >
        <Modal.Header closeButton onClick={handleCloseModal}>
          <Modal.Title>
            <Text type="subtitle" color="dark">
              Método de pagamento cadastrado!
            </Text>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Text type="body" color="dark">
            Deseja ir para listagem de métodos ou cadastrar um novo?
          </Text>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => navigate('/formas-de-pagamento')}>
            <Text weight={500} type="regular">
              Ver listagem
            </Text>
          </Button>
          <Button variant="primary" onClick={() => window.location.reload()}>
            <Text weight={500} type="regular">
              Adicionar novo
            </Text>
          </Button>
        </Modal.Footer>
      </Modal>
      <Row>
        <Col lg={12} md={12} xs={12}>
          <Card
            header={
              <Text color="#464E5F" type="header">
                Cadastro de formas de pagamento
              </Text>
            }
          >
            <Row>
              <Col xs={12}>
                <Input
                  label="Meio de pagamento"
                  value={paymentMethod}
                  onChange={(event) => setPaymentMethod(event.target.value)}
                />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </ApplicationLayout>
  );
}

export default Register;
